
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/(ocelot)/video/show/[title]/[showId]",
      function () {
        return require("private-next-pages/(ocelot)/video/show/[title]/[showId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/(ocelot)/video/show/[title]/[showId]"])
      });
    }
  